import { Markdown as UiKitMarkdown } from '@symphona/ui-kit';

interface MarkdownProps {
  text: string;
}

/**
 * Wraps ui-kit's Markdown to escape `$` signs that would otherwise be
 * interpreted as LaTeX math delimiters by remark-math.
 */
export const Markdown = ({ text }: MarkdownProps) => {
  const escaped = text.replace(/\$/g, '\\$');
  return <UiKitMarkdown text={escaped} />;
};
